import { render, staticRenderFns } from "./WeeklyTips.vue?vue&type=template&id=32b3e86e&scoped=true"
import script from "./WeeklyTips.vue?vue&type=script&lang=js"
export * from "./WeeklyTips.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTips.vue?vue&type=style&index=0&id=32b3e86e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b3e86e",
  null
  
)

export default component.exports